import React from "react";
import { Link } from "react-router-dom";
import Collapsible from "react-collapsible";
import { Colors } from "../../utils/variables";

export default function FAQ({ showTitle = true, title = "FAQ" }) {
  return (
    <>
      {showTitle && <h1 className="centered-text">{title}</h1>}
      <div className="medium-max-width-container shadow" style={{ color: Colors.white, backgroundColor: Colors.primaryDark }}>
        <Collapsible trigger="What is included in my weekend registration?">
          <ul className="subheading">
            <li>{'Welcome Party appetizers, a hearty breakfast and grab and go lunch options each day, and dinner Saturday evening.'}</li>
            <li>{'Group rides, shuttles, bike patrol for medical support'}</li>
            <li>{'Trail Building Workshop'}</li>
            <li>{'Wellness Classes'}</li>
            <li>{'Trail Talks'}</li>
            <li>{'Ibis Bike Demos'}</li>
          </ul>
        </Collapsible>
        <Collapsible trigger="What is NOT included in my weekend registration?">
          <ul className="subheading">
            <li>{'Lodging is not included.'}</li>
            <li>{'Bike Skills Clinics are not included.'}</li>
            <li>{'Alcohol is not included.'}</li>
          </ul>
        </Collapsible>
        <Collapsible trigger="What to bring?">
          <ul className="subheading">
            <li>{'A freshly tuned, comfortable to you bike'}</li>
            <li>{'backpack/hip pack'}</li>
            <li>{'Helmet, full finger gloves, glasses'}</li>
            <li>{'water, plenty of snacks, and lunch'}</li>
            <li>{'spare tube and supplies to fix a flat'}</li>
            <li>{'rain jacket'}</li>
            <li>{'shirt and extra layers as needed'}</li>
            <li>{'bike shoes/socks'}</li>
            <li>{'bike pants/shorts, chamois'}</li>
            <li>{'knee pads'}</li>
            <li>{'post ride comfortable clothing'}</li>
            <li>{'snacks, lots of snacks'}</li>
            <li>{'food for lunches on the trail'}</li>
            <li>{'Yoga Mat'}</li>
          </ul>
        </Collapsible>
        <Collapsible trigger="What should my skill level be, am I a good fit?">
          <p className="subheading">{'We plan to have a variety of group rides available all weekend for Beginners to Advanced riders. You will be encouraged to choose to ride whichever trail suits you best! '}</p>
        </Collapsible>
        <Collapsible trigger="Are your retreats e-bike friendly?">
          <p className="subheading">{'We love e-bikes!  Due to the nature of our retreat and to ensure a consistent experience for all participants, at this time we will not allow e-bikes at our retreats.'}</p>
        </Collapsible>
        <Collapsible trigger="What is your cancellation/refund policy?">
          <p className="subheading">{'Once you sign up we work extremely hard to make sure this will be an incredibly memorable and worthwhile weekend, therefore we will not honor cancellations.  We plan to ride rain, snow, or shine.  In the event, conditions are unsafe we will reschedule the event and your registration will be honored at a future event.'}</p>
        </Collapsible>
        <Collapsible trigger="How old do I have to be to attend this event?">
          <p className="subheading">{'Peak Pursuits welcomes all riders who are 18 years or older who identify as female to join our retreats.'}</p>
        </Collapsible>
        <Collapsible trigger="Do you offer any lodging options?">
          <p className="subheading">{'Yes! We encourage you to stay with us at Kirkwood! In order to receive the Peak Pursuits special group rate please call (855) 948-0694. This is a reservation line dedicated to making reservations for group guests. Guests can call every day from 8am-5pm MT. Please refer to the group code: '}<b>{'SKWPPB25'}</b>{' or the group name:  Peak Pursuits 25 when making your reservation. The nightly set rates for lodging at the Mountain Club at Kirkwood Mountain Resort for Peak Pursuits participants will be $149 for a Queen/Queen, $164 for a studio, and $179 for a studio plus loft + taxes and fees'}</p>
        </Collapsible>
        <Collapsible trigger="Do you offer camping options?">
          <p className="subheading">{'Yes! We offer camping for confirmed Free to Roam participants. There are 25 spots available on a first come, first serve basis at $75 for the weekend per campsite. Camping is located in the Upper Red Cliffs parking lot at Kirkwood Mountain Resort. Check-in starts 8/14/27 from 12pm-7pm and check-out is 8/16/27 by 4pm. For more detailed camping information, visit our '}<Link to="/camping" style={{ color: '#fff', fontWeight: 'bold' }}>{'Camping page'}</Link>{'.'}</p>
        </Collapsible>
        <Collapsible trigger="How can I be part of the amazing volunteer squad?">
          <p className="subheading">{"We're so excited you want to join the fun! Volunteering with us is simple and super rewarding. Head over to the Forms and Documents page and fill out the volunteer application. We can't wait to hear about how awesome you are!"}</p>
        </Collapsible>
        <Collapsible trigger="Who do I contact if I have any further questions?">
          <p className="subheading">{'You can contact us! Please email '}<a style={{ color: '#fff', fontWeight: 'bold' }} href="mailto:peakpursuitsmtnbiking@gmail.com">{'peakpursuitsmtnbiking@gmail.com'}</a>{" and we'll reply faster than a chipmunk dodging a mountain bike. (Okay, maybe not that fast, but close!)"}</p>
        </Collapsible>
      </div>
    </>
  );
}
